import { render, staticRenderFns } from "./Footer4Col.vue?vue&type=template&id=77ab7924&"
import script from "./Footer4Col.vue?vue&type=script&lang=js&"
export * from "./Footer4Col.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports